<script>
  import { onMount } from "svelte";
  import EmailList from "../EmailList/EmailList.svelte";
  import {External, M} from "../external";

  let tab = "system",
    data = {};

  let tooltipOptions = function (template) {
    return [
      {
        text: template.enabled ? M.DISABLE_EMAIL : M.ENABLE_EMAIL,
        icon: template.enabled ? "fa-eye-slash" : "fa-eye",
        tag: template.enabled ? "disable" : "enable"
      },
      { text: M.RESET_EMAIL, icon: "fa-trash", tag: "reset" }
    ];
  };

  let onTabChange = function (t) {
    tab = t;
    getTemplates();
  };

  let getTemplateByName = function (name) {
    let templates = data.templates || [];
    for (let idx = 0; idx < templates.length; ++idx) {
      if (templates[idx].name === name) return templates[idx];
    }
    return null;
  };

  let getEmailBuilderFeatures = function(name) {
    let features = {};
    if (name === "new_order_pending" || name === "new_order_shipped" || name === "new_order_completed" || name === "new_order_cancelled" || name === "new_order_admin") {
      features.hasOrderDetailsWidget = true;
    } else if (name === "digital_goods_download_email") {
      features.hasDownloadWidget = true;
    }
    return features;
  }

  let onClick = function (name, action) {
    if (!action) {
      let features = encodeURIComponent(JSON.stringify(getEmailBuilderFeatures(name)));
      if (tab === "admin") {
        External.CPanel.goToUrl("/me/crm/marketing/builder?is_wl=true&is_system=true&name=" + name + "&features=" + features , true);
      } else {
        External.CPanel.goToUrl("/me/crm/marketing/builder?is_system=true&name=" + name + "&features=" + features, true);
      }
    } else if (action === "enable" || action === "disable") {
      External.Tools.makeWebsiteRequest({
        action: "changeSystemEmailStatus",
        data: {
          name: name,
          enable: action === "enable"
        },
        onOk: function () {
          getTemplateByName(name).enabled = action === "enable";
          data = data;
        }
      });
    } else if (action === "reset") {
      External.Tools.prompt(M.DEL_CONFIRM, M.RESET_EMAIL_QST, function () {
        External.Tools.makeWebsiteRequest({
          action: "resetSystemEmail",
          data: {
            name: name
          },
          onOk: function () {
            getTemplateByName(name).enabled = true;
            data = data; 
          }
        });
      });
    }
  };

  let getTemplates = function () {
    External.Tools.makeWebsiteRequest({
      action: "getSystemEmailTemplates",
      data: {
        admin: tab === "admin"
      },
      onOk: function (response) {
        if (response.data == null) {
          return;
        }

        data = response.data;
      }
    });
  };

  onMount(getTemplates);

</script>

{#if External.subdomain === "www"}
  <ul class="upper-navigation upper-navigation-full mb-15">
    <li>
      <a class:active={tab === "system"} on:click={() => onTabChange("system")}>
        {M.SENT_TO_VISITORS}
      </a>
    </li>
    <li>
      <a class:active={tab === "admin"} on:click={() => onTabChange("admin")}>{M.SENT_TO_ADMINISTRATORS}</a>
    </li>
  </ul>
{/if}

<div class="col20 f-left email-section-description">
  {tab === "admin"
    ? M.SYSTEM_EMAILS_CUSTOMERS
    : M.SYSTEM_EMAILS_END}
</div>
<EmailList {data} {onClick} useStaticImage={false} {tooltipOptions} showDisabledBadge={true} isSystem={true} />
